/**
 * product-extended.js
 *
 * Runs AFTER product-custom.js (both are deferred, document order matters).
 * Responsibilities:
 *   1. Override delivery date with the schema-configured cutoff time
 *      (product-custom.js hardcodes 16:00; we read the data-cutoff attribute)
 *   2. Activate the first visible tab (handles tabs that may be hidden by schema)
 *   3. Mobile: tabs → accordion on narrow screens
 *
 * Does NOT re-implement qty stepper, ATB proxy, wishlist proxy, or VAT price
 * since those are fully handled by product-custom.js.
 */

(function () {
  'use strict';

  // ─────────────────────────────────────────────────────────────────
  // 1.  DELIVERY DATE — respects the data-cutoff attribute set by Liquid
  // ─────────────────────────────────────────────────────────────────
  function updateDeliveryDate() {
    var el = document.getElementById('cc-delivery-date');
    if (!el) return;

    // Read cutoff from the element's data attribute (set by section settings)
    var cutoffStr = (el.dataset.cutoff || '16:00').trim();
    var parts     = cutoffStr.split(':');
    var cutHour   = parseInt(parts[0], 10) || 16;
    var cutMin    = parseInt(parts[1], 10) || 0;

    var now    = new Date();
    var cutoff = new Date(now);
    cutoff.setHours(cutHour, cutMin, 0, 0);

    // If now >= cutoff, dispatch is tomorrow; add an extra day
    var d = new Date(now);
    d.setDate(d.getDate() + (now >= cutoff ? 2 : 1));
    d.setHours(0, 0, 0, 0);

    // Skip weekends
    while (d.getDay() === 0 || d.getDay() === 6) {
      d.setDate(d.getDate() + 1);
    }

    var days   = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    var months = ['January','February','March','April','May','June',
                  'July','August','September','October','November','December'];

    el.textContent = days[d.getDay()] + ', ' + d.getDate() + ' ' + months[d.getMonth()];
  }

  // ─────────────────────────────────────────────────────────────────
  // 2.  TABS — ensure the first VISIBLE tab is activated
  //     product-custom.js activates tabBtns[0] which may be hidden
  //     if section.settings disabled a tab. We re-activate here.
  // ─────────────────────────────────────────────────────────────────
  function activateFirstTab() {
    var tabBtns   = Array.from(document.querySelectorAll('.cc-tab-btn'));
    var tabPanels = Array.from(document.querySelectorAll('.cc-tab-panel'));

    if (!tabBtns.length) return;

    // Deactivate all
    tabBtns.forEach(function (b) {
      b.classList.remove('is-active');
      b.setAttribute('aria-selected', 'false');
    });
    tabPanels.forEach(function (p) { p.classList.remove('is-active'); });

    // Find first visible btn
    var first = tabBtns.find(function (b) {
      return b.offsetParent !== null;
    });

    if (!first) return;

    first.classList.add('is-active');
    first.setAttribute('aria-selected', 'true');

    var target = first.dataset.tab;
    var panel  = document.getElementById('cc-tab-' + target);
    if (panel) panel.classList.add('is-active');
  }

  // ─────────────────────────────────────────────────────────────────
  // 3.  MOBILE ACCORDION
  //     On screens ≤ 600 px, clicking a tab header toggles the panel
  //     open/closed (accordion behaviour) instead of just switching.
  // ─────────────────────────────────────────────────────────────────
  function patchTabsForMobile() {
    var tabBtns = document.querySelectorAll('.cc-tab-btn');
    if (!tabBtns.length) return;

    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (window.innerWidth > 600) return; // desktop handled by product-custom.js

        var target  = btn.dataset.tab;
        var panel   = document.getElementById('cc-tab-' + target);
        var isOpen  = btn.classList.contains('is-active');

        // Close all
        document.querySelectorAll('.cc-tab-btn').forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        document.querySelectorAll('.cc-tab-panel').forEach(function (p) {
          p.classList.remove('is-active');
        });

        // Toggle open if it was closed
        if (!isOpen && panel) {
          btn.classList.add('is-active');
          btn.setAttribute('aria-selected', 'true');
          panel.classList.add('is-active');
          // Smooth scroll to the opened panel
          setTimeout(function () {
            panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }, 50);
        }
      });
    });
  }

  // ─────────────────────────────────────────────────────────────────
  // INIT
  // ─────────────────────────────────────────────────────────────────
  function init() {
    // Delivery date: product-custom.js runs first with hardcoded 16:00.
    // We overwrite immediately after with the settings-based cutoff.
    updateDeliveryDate();

    // Re-activate first visible tab (in case schema disabled tab[0])
    activateFirstTab();

    // Patch tab clicks for mobile accordion
    patchTabsForMobile();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
